import { httpClient } from '../Common/api/http_client';

// eslint-disable-next-line no-return-await
const service = {
  login(data) {
    return httpClient.post('/login', data);
  },

  merchantPasswordChange(data) {
    return httpClient.post('merchant/merchant_password_change', data);
  },

  forgotPassword(data) {
    return httpClient.post('/forgotPassword', data);
  },

  passwordReset(data) {
    return httpClient.get(`resetPassword/${data.token}?newPassword=${data.newPassword}`);
  },

  logout() {
    return httpClient.get('/logout');
  },

  merchant() {
    return httpClient.get('/merchant');
  },
};

export default service;
